// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import axios from '@/utils/request.js'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import Points from '@/assets/js/buryingPoint.js'
import './assets/icon/iconfont.css'
import 'element-ui/lib/theme-default/index.css'
import 'video.js/dist/video-js.min.css'
import 'babel-polyfill'
Vue.prototype.axios = axios


Vue.config.productionTip = false

Vue.use(VueDOMPurifyHTML, {
    default: {
      ADD_ATTR: ['target'],
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|about):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i
    },
    /*hooks: {
      afterSanitizeAttributes: (node, data) => {
        if (node.nodeName && node.nodeName.toLowerCase() === 'a' && !node.hasAttribute('href')) {
          node.setAttribute('href', 'about:blank')
        }
      }
    }*/
  }
)
Vue.use(ElementUI)
Vue.prototype.$Points = Points;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js